// UAE dirham peg is ~3.6725 to USD. Using 3.67 for simpler mental math.
export const AED_PER_USD = 3.67;

/**
 * @param {number} amount - amount in baseCurrency
 * @param {string} baseCurrency - currency stored in pricing API (e.g. 'AED', 'MAD', 'USD')
 * @param {string} baseSymbol - symbol to display for baseCurrency (e.g. 'AED', 'MAD', '$')
 * @param {'prefix'|'suffix'} basePosition - where to place the symbol
 * @param {'AED'|'USD'|'MAD'|undefined} displayCurrency - optional override
 */
export function formatCurrency(amount, baseCurrency, baseSymbol, basePosition, displayCurrency) {
  const display = displayCurrency || baseCurrency;

  if (baseCurrency === 'AED' && display === 'USD') {
    const usd = Math.round(amount / AED_PER_USD);
    return `$${usd}`;
  }

  const rounded = Number.isInteger(amount) ? amount : Number(amount).toFixed(2);
  return basePosition === 'prefix' ? `${baseSymbol}${rounded}` : `${rounded} ${baseSymbol}`;
}
